import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { Spinner } from '@mobi/component-library/Common/Spinner'
import type { PrecommitmentResponse } from '@mobi/account/Areas/SignUp/Utils/SignUpApi'
import { get } from '@classic/Foundation/Services/ApiService'
import { MainContainer } from '@core/Components/Containers'
import { queryKeys } from '@mobi/account/Utils'
import { precommitmentUrl } from '@mobi/account/Utils'
import { PrecommitmentForm } from './PrecommitmentForm'

export const PrecommitmentPage: React.FC = () => {
  const { isLoading, isError, data } = useQuery<PrecommitmentResponse>({
    queryKey: [queryKeys.precommitmentDetails],
    queryFn: () => get({ url: precommitmentUrl.precommitmentDetails }),
    retry: false,
    refetchOnWindowFocus: false,
  })

  return (
    <MainContainer background='white' testId='precommitment'>
      <PageHeader title='Bet Limits' />

      {isLoading && <Spinner />}
      <PrecommitmentForm data={data} hasDataFetchFailed={isError} />
    </MainContainer>
  )
}
